import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { SERVER_ENDPOINT } from '@vbrick/vb-lxp-lib';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  MAIN_STREAM_DATA,
  STREAM_DATA,
} from 'projects/vb-lxp-lib/src/lib/shared/stream.token';
import streamingData from 'projects/vb-lxp-sro/data/streaming-data.json';
import mainStreamData from 'projects/vb-lxp-sro/data/main-stream-data.json';

import { environment } from 'projects/vb-lxp-sro/src/environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    {
      provide: SERVER_ENDPOINT,
      useValue: environment.serverEndpoint,
    },
    {
      provide: STREAM_DATA,
      useValue: streamingData,
    },
    {
      provide: MAIN_STREAM_DATA,
      useValue: mainStreamData,
    },
    provideHttpClient(),
    provideAnimations(),
  ],
};
